import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-relieve-outbreak-pain',
  templateUrl: './relieve-outbreak-pain.component.html',
  imports: [UpsellCardComponent],
})
export class RelieveOutbreakPainComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.LidocaineOintment;
}
